import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { map, filter } from 'rxjs/operators';
import { AuthGuardMessageService } from './auth-guard.message.service';
import { environment } from 'src/environments/environment';
import { UserRole } from 'src/app/shared/models/constants/user-role.constant';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private loggerService: LoggerService,
    private authGuardMessageService: AuthGuardMessageService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    if (environment.enableAuthentication) {
      this.loggerService.log('isLogged in? :', this.authService.isLoggedIn());
      if (!this.authService.isLoggedIn()) {
        // TODO: redirect to login page
        return of(false);
      } else {
        return this.authService.isUserDataLoaded$.pipe(filter(x => x === true), map((isLoaded) => {
          const userDetails = this.authService.getUserDetails();
          if (!userDetails.hasProductManagementPermission) {
            // User doesn't have ProductManagement Permission
            this.sendErrorValue(true);
            return false;
          }
          if (route.data.expectedRole !== undefined) {
            // Checks if user is of type internal user or Regional internal user to show him pages he has access
            if (userDetails.userType !== UserRole.CustomerUser) {
              this.sendErrorValue(false);
              return true;
            } else {
              // Redirect to Product Page if he is of Customer User type
              this.sendErrorValue(true);
              return false;
            }
          } else {
            // Default behavior ie. user need not have specific permission to access page
            this.sendErrorValue(false);
            return true;
          }
        }));
      }
    }
  }

  sendErrorValue(value: boolean) {
    this.authGuardMessageService.userDeniedPermission.next(value);
  }
}
